var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',[_c('voucher-segment-list',{attrs:{"infinite-id":_vm.infiniteId},on:{"reload":_vm.reload}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }